import { createPortalApp } from '@openchoreo/backstage-portal-app';

export default createPortalApp().createRoot();
